import { apiCall } from '../../utils';

export const getBusinessCategories = params =>
  apiCall({
    url: '/coupons/categories/',
    method: 'get',
    params,
  });
